<template>
  <div class="akl"><div class="bod-view-txt">
  <!-- 반응형 공지 시작 -->
  <div class="os_noticeRes">
      <!-- header -->
      <div class="osResHeader" style="background-color:#cadad3;">
          <div class="widL padTL txtC">
              <p class="fntH1 bold" style="color:#231f5c;line-height:1.18">
                  너랑 나랑 나트랑<br>
                  <span class="disIb">2020 회계연도</span><br class="pcOnly">
                  <span class="disIb">여행 프로모션 시행</span>
              </p>
              <p class="posRe fntH5" style="top:1.5em;color:#212121;">
                  2020 회계연도 리더십 세미나의 또 다른 이름,<br>
                  <b class="disIb padTS padBS fntH4 bolder" style="color:#000">“너랑 나랑 나트랑”</b><br>
                  한 해의 성공을 함께 나누는 곳, <span class="disIb">나트랑에 더 많은 사업자분들을 모시기 위해 </span> <br class="pcOnly">
                  Amway Korea에서는 다양한 프로모션을 준비했습니다. <span class="disIb">아래 내용을 참고 부탁드립니다.</span>
              </p>
              <img src="https://www.amway.co.kr/_ui/_noticeImg/2019/09/0920_nca/vis.png" alt="">
          </div>
      </div>
      <!-- //osResHeader -->
      <!-- //header -->
      <!-- content -->
      <div style="color:#56565a;">
          <!-- 프로모션 1 -->
          <div class="cont1" style="background-color:#fff;">
              <div class="widL padTL txtC">
                  <div class="marBML padTS">
                      <img src="https://www.amway.co.kr/_ui/_noticeImg/2019/09/0920_nca/icon01.png" alt="">
                      <p class="marTS fntH3 bold" style="color:#0070b0;">프로모션 1</p>
                      <p class="padTS  fntH4 light">9월 여행점수 20% UP</p>
                  </div>
                  <div class="padBL fntH6 fntL txtC">
                      <div class="clearfix">
                          <p class="marBM bold" style="float:left;background:#3bb2d0;width:20%;padding:3px 0;color:#fff;border-radius:2em;line-height:1.5;">기간</p>
                          <p class="marBM fntH5 light txtL" style="float:right;width:80%;padding-top:3px;padding-left:1em;">2019년 9월</p>
                      </div>
                      <div class="clearfix">
                          <p class="marBM bold" style="float:left;background:#3bb2d0;width:20%;padding:3px 0;color:#fff;border-radius:2em;line-height:1.5;">대상</p>
                          <p class="marBM fntH5 light txtL" style="float:right;width:80%;padding-top:3px;padding-left:1em;">해당기간 SP 유자격 월을 달성한 모든 ABO</p>
                      </div>
                      <div class="clearfix">
                          <p class="bold" style="float:left;background:#3bb2d0;width:20%;padding:3px 0;color:#fff;border-radius:2em;line-height:1.5;">혜택</p>
                          <p class="fntH5 light txtL" style="float:right;width:80%;padding-top:3px;padding-left:1em;">9월 해당 월 달성 여행점수의 20% 추가</p>
                      </div>
                  </div>
              </div>
          </div>
          <!-- //프로모션 1 -->

          <!-- 프로모션 2 -->
          <div class="cont2" style="background-color:#f4f4f4;">
              <div class="widL padTL txtC">
                  <div class="marBML padTS">
                      <img src="https://www.amway.co.kr/_ui/_noticeImg/2019/09/0920_nca/icon02.png" alt="">
                      <p class="marTS fntH3 bold" style="color:#231f5c;">프로모션 2</p>
                      <p class="padTS  fntH4 light">4차수 이상 도전자 조건완화</p>
                  </div>
                  <div class="padBL fntH6 fntL txtC">
                      <div class="clearfix">
                          <p class="marBM bold" style="float:left;background:#62727f;width:20%;padding:3px 0;color:#fff;border-radius:2em;line-height:1.5;">기간</p>
                          <p class="marBM fntH5 light txtL" style="float:right;width:80%;padding-top:3px;padding-left:1em;">2019년 09월 ~ 2020년 08월</p>
                      </div>
                      <div class="clearfix">
                          <p class="marBM bold" style="float:left;background:#62727f;width:20%;padding:3px 0;color:#fff;border-radius:2em;line-height:1.5;">대상</p>
                          <p class="marBM fntH5 light txtL" style="float:right;width:80%;padding-top:3px;padding-left:1em;">여행차수 4차 이상에 도전하시는 2020 회계연도 마감 유자격 플래티늄 이상 ABO</p>
                      </div>
                      <div class="clearfix">
                          <p class="bold" style="float:left;background:#62727f;width:20%;padding:3px 0;color:#fff;border-radius:2em;line-height:1.5;">조건</p>
                          <div class="marBM fntH5 light txtL" style="float:right;width:80%;padding-top:3px;padding-left:1em;">아래 조건 1) & 2) 모두 달성 시 나트랑 리더십 세미나 초청
                              <div class="marTS fntH6 fntL light">
                                  <ol>
                                      <li>1) 2019 회계연도 대비 여행점수 240만점 이상 성장</li>
                                      <li>2) 2020 회계연도 마감 여행점수 1,040만점 이상 달성</li>
                                  </ol>
  <!--                                <p class="marTM">※ 여행은 기존 조건(1,520만점) 으로도 달성이 가능합니다. </p>-->
                                  <p class="marTM">※ 4차수에 도전하는 경우 달성 사례 예시</p>
                                  <ul>
                                      <li class="marTS">- 4차수 목표 점수(1,520만점)로 달성 :
                                          <p class="fntH6 light">2019 회계연도 1,400만점으로 마감한 후 올해 여행점수 달성을 위해 120만점을 성장하여 1,520만점 목표 점수 달성 시 리더십 세미나 참석이 가능합니다.</p>
                                      </li>
                                      <li class="marTS">- 프로모션 조건(1,040만점 및 240만점 성장)으로 달성 :
                                          <p class="fntH6 light">2019 회계연도 1,200만점으로 마감하고 올해 1,440만점을 달성한 4회차 도전자의 경우 올해 총 여행점수가 1,040만점 이상이며, 전년 대비 240만점을 성장 시켰으므로 프로모션 조건을 통해 리더십 세미나 참석이 가능합니다.</p>
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <!-- //프로모션 2 -->
      </div>
      <!-- 2020 회계연도 리더십 세미나 추가 프로모션 시행 안내 20.04.14 추가 -->
      <div class="cont3 marTL" style="background-color:#cadad3;">
          <div class="widL padTXL padBXL txtC">
              <p class="fntH2 fntL bold" style="color:#231f5c;line-height:1.18;letter-spacing:-3.5px;">
                  2020 회계연도 리더십 세미나 <br>
                  추가 프로모션 시행 안내
              </p>
              <p class="marTL fntH6 fntL" style="color:#212121;">
                  전세계적인 코로나19의 대유행으로 교육 및 미팅조차 쉽지 않은 시기입니다. 그러나 대면 활동이 여러 방면으로 차단된 이 어려운 시기에도 Amway 비즈니스를 지속적으로 이끌어 나가는 여러분들의 노력과 헌신이 그 어느 때보다 귀하고 값지다고 생각되며, 이에 Amway Korea는 우선 <span class="disIb">감사의 말씀을 드리고 싶습니다.</span> <br><br>

                  코로나19 장기화로 인한 스트레스로 자칫 무기력해질 수 있는 상황이지만 그러한 어려움 속에서도 비즈니스 성장에 대한 노력을 보여주시는 리더 분들께 힘을 실어드리고, <span class="disIb">리더십 세미나 자격 달성에</span> <span class="disIb">한걸음 더 다가가는데 도움이 되고자 추가 여행 프로모션을 준비했습니다. </span><br>아래 내용을 참고 부탁드립니다.
              </p>
          </div>
    </div>
    <div style="color:#56565a;">
    <!-- 프로모션 1 -->
      <div style="background-color:#fff;">
          <div class="widL padTL txtC">
              <div class="marBML padTS">
                  <img src="https://www.amway.co.kr/_ui/_noticeImg/2019/09/0920_nca/icon01.png" alt="" class="icoS">
                  <p class="marTS fntH3 bold" style="color:#0070b0;">345월 여행점수 10% UP</p>
              </div>
              <div class="padBL fntH6 fntL txtC">
                  <div class="clearfix">
                      <p class="marBM bold" style="float:left;background:#3bb2d0;width:20%;padding:3px 0;color:#fff;border-radius:2em;line-height:1.5;">기간</p>
                      <p class="marBM fntH5 light txtL" style="float:right;width:80%;padding-top:3px;padding-left:1em;">2020년 3월 ~ 5월(3개월간)</p>
                  </div>
                  <div class="clearfix">
                      <p class="marBM bold" style="float:left;background:#3bb2d0;width:20%;padding:3px 0;color:#fff;border-radius:2em;line-height:1.5;">대상</p>
                      <p class="marBM fntH5 light txtL" style="float:right;width:80%;padding-top:3px;padding-left:1em;">해당 기간 SP 유자격 월을 달성한 <span class="disIb">모든 ABO</span></p>
                  </div>
                  <div class="clearfix">
                      <p class="bold" style="float:left;background:#3bb2d0;width:20%;padding:3px 0;color:#fff;border-radius:2em;line-height:1.5;">혜택</p>
                      <p class="fntH5 light txtL" style="float:right;width:80%;padding-top:3px;padding-left:1em;">해당 월 달성 여행 점수의 10% 추가</p>
                  </div>
              </div>
          </div>
      </div>
      <!-- //프로모션 1 -->
      
      <!-- 프로모션 2 -->
      <div style="background-color:#f4f4f4;">
          <div class="widL padTL txtC">
              <div class="marBML padTS">
                  <img src="https://www.amway.co.kr/_ui/_noticeImg/2019/09/0920_nca/icon02.png" alt="" class="icoS">
                  <p class="marTS fntH3 bold" style="color:#231f5c;">나트랑 with Family</p>
              </div>
              <div class="padBL fntH6 fntL txtC">
                  <div class="clearfix">
                      <p class="marBM bold" style="float:left;background:#62727f;width:20%;padding:3px 0;color:#fff;border-radius:2em;line-height:1.5;">기간</p>
                      <p class="marBM fntH5 light txtL" style="float:right;width:80%;padding-top:3px;padding-left:1em;">2019년 9월 ~ 2020년 8월</p>
                  </div>
                  <div class="clearfix">
                      <p class="marBM bold" style="float:left;background:#62727f;width:20%;padding:3px 0;color:#fff;border-radius:2em;line-height:1.5;">대상</p>
                      <p class="marBM fntH5 light txtL" style="float:right;width:80%;padding-top:3px;padding-left:1em;">여행점수를 최종적으로 달성한 <span class="disIb">모든 ABO</span></p>
                  </div>
                  <div class="clearfix">
                      <p class="bold" style="float:left;background:#62727f;width:20%;padding:3px 0;color:#fff;border-radius:2em;line-height:1.5;">혜택</p>
                      <div class="marBM fntH5 light txtL" style="float:right;width:80%;padding-top:3px;padding-left:1em;">
                        여행 참석 대상을 자녀에서 가족으로 확대<br>
                        <p class="marTS fntH6 light">※ 가족 범위는 형제/부모/자녀 및 자녀의 배우자/손자녀이며, 동반 가족 최대 인원은 2명입니다. <br>(단, 동반가족이 전원 자녀만으로 구성될 경우 인원 제한 없음.)</p>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- //프로모션 2 -->
      <div class="padTL padBL">
        <p class="widL fntH6 fntL light txtC">건강에 늘 유의하시길 바라며, 많은 리더님들과 <span class="disIb">함께할 수 있기를 바라겠습니다.</span></p>
      </div>

    </div>
      <!-- // 2020 회계연도 리더십 세미나 추가 프로모션 시행 안내 20.04.14 추가 -->
      <!-- //content -->
  </div>
  <!-- //os_noticeRes -->
  <!-- //반응형 공지 끝 -->
  </div><!-- //.bod-view-txt --></div><!-- //.akl -->
</template>

<script>
export default {
  name: 'leader-seminar',
  data () {
    return {}
  },
  methods: {

  }
}
</script>

<style>
@import 'font_kr.css';
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/style.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-lib.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/base.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common.css');
/*신규 페이지 모바일 실제크기 적용*/
body{max-width:1400px;margin:0 auto;}
@media screen and (max-width:639px) {
  body{padding-left:15px;padding-right:15px;margin:0 auto;}
}
</style>


// WEBPACK FOOTER //
// src/views/leader-seminar/notice.vue